import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';
import { ActiveCartService } from '@cart/data-access';
import { ProductReviewsService } from '@reviews/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { PromotionLocation, PromotionResult } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderItemComponent implements OnChanges, OnInit {
  @Input() item: CustomOrderEntry;
  @Input() appliedProductPromotions: PromotionResult[];
  @Input() compact = false;

  @Input() promotionLocation: PromotionLocation = PromotionLocation.ActiveCart;

  iconType = CUSTOM_ICON_TYPE;

  isGifted = false;
  hasActiveVoucher$: Observable<boolean>;
  reviewsAverageRating$: Observable<number>;

  constructor(
    private activeCartService: ActiveCartService,
    private productReviewsService: ProductReviewsService,
  ) {}

  ngOnChanges(changes?: SimpleChanges): void {
    if (changes?.item) {
      this.isGifted = changes.item.currentValue?.basePrice?.value === 0;
    }
  }

  ngOnInit(): void {
    this.hasActiveVoucher$ = this.activeCartService.getActive().pipe(map((cart) => !!cart?.appliedVouchers?.length));
    this.reviewsAverageRating$ = this.productReviewsService.getAverageRating(this.item.product.code);
  }
}
